// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3J2Pv","label":"styles_label__3XoEO"};